module.exports = __webpack_public_path__ + "static/media/img-quiz-8.6c131eb4.jpg";